import {
  Alert,
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Snackbar
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { refreshBigQueryDataUsecase } from 'src/api/dashboard/usecases/refresh-big-query-data.usecase';
import { useSuspiciousUsersIndicator } from 'src/hooks/useSuspiciousUsersIndicator';

const ListWrapper = styled(Box)(
  ({ theme }) => `
        .MuiTouchRipple-root {
            display: none;
        }
        
        .MuiListItem-root {
            transition: ${theme.transitions.create(['color', 'fill'])};
            
            &.MuiListItem-indicators {
                padding: ${theme.spacing(1, 2)};
            
                .MuiListItemText-root {
                    .MuiTypography-root {
                        &:before {
                            height: 4px;
                            width: 22px;
                            opacity: 0;
                            visibility: hidden;
                            display: block;
                            position: absolute;
                            bottom: -10px;
                            transition: all .2s;
                            border-radius: ${theme.general.borderRadiusLg};
                            content: "";
                            background: ${theme.colors.primary.main};
                        }
                    }
                }

                &.active,
                &:active,
                &:hover {
                
                    background: transparent;
                
                    .MuiListItemText-root {
                        .MuiTypography-root {
                            &:before {
                                opacity: 1;
                                visibility: visible;
                                bottom: 0px;
                            }
                        }
                    }
                }
            }
        }
`
);

const DotIndicator = styled(Box)(
  ({ theme }) => `
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${theme.colors.error.main};
    margin-left: 7px;
    margin-top: -10px;
  `
);

function HeaderMenu() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [isOpen2, setOpen2] = useState<boolean>(false);
  const [isRefreshAlertOpen, setRefreshAlertOpen] = useState(false);
  const [isRefreshSuccess, setIsRefreshSuccess] = useState(false);
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);

  const { data: newAlertsTimestamp } = useSuspiciousUsersIndicator();

  useEffect(() => {
    console.log('newAlertsTimestamp', newAlertsTimestamp);
  }, [newAlertsTimestamp]);

  const handleLookerRefresh = async () => {
    setIsRefreshLoading(true);

    try {
      await refreshBigQueryDataUsecase();
      setIsRefreshLoading(false);
      setIsRefreshSuccess(true);
      setRefreshAlertOpen(true);
    } catch {
      setIsRefreshSuccess(false);
      setRefreshAlertOpen(true);
    }
  };

  const handleOpen = (): void => {
    setOpen(true);
  };
  const handleOpen2 = (): void => {
    setOpen2(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const handleClose2 = (): void => {
    setOpen2(false);
  };

  return (
    <>
      <ListWrapper>
        <List disablePadding component={Box}>
          <ListItem
            classes={{ root: 'MuiListItem-indicators' }}
            button
            ref={ref}
            onClick={handleOpen}
          >
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary={
                <Box display="flex" alignItems="center">
                  eSIMo
                  <Box display="flex" alignItems="center" pl={0.3}>
                    <ExpandMoreTwoToneIcon fontSize="small" />
                  </Box>
                </Box>
              }
            />
          </ListItem>
        </List>
      </ListWrapper>
      <Menu anchorEl={ref.current} onClose={handleClose} open={isOpen}>
        {/*<MenuItem sx={{ px: 3 }} component={NavLink} to="/dashboards/dashboard" onClick={handleClose}>*/}
        {/*  Dashboard*/}
        {/*</MenuItem>*/}
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/purchases"
          onClick={handleClose}
        >
          Purchases
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/users"
          onClick={handleClose}
        >
          Users
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/suspicious-users"
          onClick={handleClose}
        >
          Suspicious Users
          {newAlertsTimestamp ? <DotIndicator /> : null}
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/businesses"
          onClick={handleClose}
        >
          Businesses
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/coupons"
          onClick={handleClose}
        >
          Coupons
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/logs"
          onClick={handleClose}
        >
          Esimoney Admin Logs
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/packages"
          onClick={handleClose}
        >
          Packages
        </MenuItem>
        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/dashboards/countries"
          onClick={handleClose}
        >
          Countries
        </MenuItem>

        <MenuItem
          sx={{ px: 3 }}
          component={NavLink}
          to="/settings"
          onClick={handleClose}
        >
          Providers
        </MenuItem>

        <Button
          disabled={isRefreshLoading}
          onClick={handleLookerRefresh}
          style={{ marginTop: '30px' }}
          variant="contained"
          fullWidth
        >
          {isRefreshLoading ? 'Refreshing...' : 'Refresh Looker'}
        </Button>

        <Snackbar
          open={isRefreshAlertOpen}
          autoHideDuration={4000}
          onClose={() => setRefreshAlertOpen(false)}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        >
          <Alert
            onClose={() => setRefreshAlertOpen(false)}
            severity={isRefreshSuccess ? 'success' : 'error'}
            sx={{ width: '100%' }}
          >
            {isRefreshSuccess
              ? 'Looker refreshed successfully'
              : 'Cannot refresh looker data'}
          </Alert>
        </Snackbar>
      </Menu>
    </>
  );
}

export default HeaderMenu;
